var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRugby(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.074 19.274l-.884.467.144.273.273.144.467-.884zM19.216 5.132l.884-.467-.144-.273-.273-.145-.467.885zM5.958 18.807c-1.426-2.701-.611-6.94 2.62-10.171L7.164 7.222c-3.64 3.64-4.935 8.805-2.974 12.519l1.768-.934zm-1.351 1.351c3.713 1.96 8.88.665 12.519-2.974l-1.414-1.415c-3.232 3.232-7.47 4.047-10.171 2.62l-.934 1.77zm12.519-2.974c3.64-3.64 4.935-8.806 2.974-12.52l-1.768.935c1.426 2.7.611 6.939-2.62 10.17l1.414 1.415zM8.578 8.636c3.232-3.232 7.47-4.046 10.171-2.62l.934-1.769c-3.713-1.96-8.88-.665-12.519 2.975l1.414 1.414z",
    fill: "#141414"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.175 14.454l5.657 5.657m.707-9.193l2.828 2.829m-3.889-.354l1.414 1.414m2.122-4.949l1.414 1.414m-.354-6.718l5.657 5.657M9.125 15.16l5.656-5.656",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
export default SvgRugby;